import { buildSoldierMessage } from '../services/ai.js';
import { getWalletInfo } from '../services/wallet.js';

export async function handleSoldierMessage(userWallet) {
  if (!userWallet) {
    window.logToConsole("🪖 Connect your wallet first.");
    return;
  }
  
  window.logToConsole("🪖 Reading mission data...");
  
  try {
    const tokens = await getWalletInfo(userWallet);
    const message = await buildSoldierMessage(tokens);
    window.logToConsole(`🪖 ${message}`);
  } catch (error) {
    console.error("Soldier error:", error);
    window.logToConsole("🪖 ERROR: Could not retrieve balance data.");
  }
}
